<template>
  <div class="consult-detail container-content">
    <div class="title">
      <h1>工作网常见问题及解答(2017版)(2017版)</h1>
      <h5>发布日期：2017-03-30</h5>
    </div>
    <div class="article">
      <p>内容待定。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'detail'
}
</script>

<style lang="less" scoped>
  .consult-detail {
    .title {
      border-bottom: 1px solid #cccccc;
      padding-bottom: 20px;
      h1 {
        text-align: center;
        margin-bottom: 20px;
      }
      h5 {
        margin: 0 auto;
        text-align: right;
        width: 600px;
      }
    }
    .article {
      text-indent: 36px;
      p {
        margin-top: 20px;
        font-size: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/consult/detail.vue